module.exports = __webpack_public_path__ + "a1a749e89f578a49306ec2b055c073da.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/brand-icons.svg
// module id = 261
// module chunks = 4